import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { empty_pagination } from '../../constants/empty_pagination';
import Agent from '../agent';

const initialState = {
  loading: false,
  clients: [],
  errors: {},
  redirectTo: null,
  currentPage: 1,
  totalPages: 1,
  nextPage: undefined,
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getClients = createAsyncThunk('clients/get', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await Agent.Clients.get(payload);
    return data;
  } catch (err) {
    let error = err;
    if (!error.response) {
      return rejectWithValue({ errors: { [err.name]: err.message } });
    }
    return rejectWithValue(error.response.body);
  }
});

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
    },
    updatePage(state, action) {
      state.currentPage = action.payload;
    },
    updateState(state, action) {
      if (state.errors[action.payload.key]) delete state.errors[action.payload.key];
      state.user[action.payload.key] = action.payload.value;
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    [getClients.pending]: (state) => {
      state.loading = true;
    },

    [getClients.fulfilled]: (state, action) => {
      let pagination = action?.payload?.pagination || empty_pagination;
      let clients = action?.payload?.clients || [];

      state.loading = false;
      state.clients =
        pagination.currentPage > 1
          ? [
              ...state.clients,
              ...clients.map((client) => {
                return {
                  ...client,
                  id: client?._id || '',
                  name: `${client?.first_name || ''} ${client?.last_name || ''}`,
                  notes: (client?.description || '').substring(0, 50),
                  last_deposited_at: client?.last_deposited_at || '--/--/--',
                };
              }),
            ]
          : clients.map((client) => {
              return {
                ...client,
                id: client?._id || '',
                name: `${client.first_name || ''} ${client.last_name || ''}`,
                notes: (client?.description || '').substring(0, 50),
                last_deposited_at: client?.last_deposited_at || '--/--/--',
              };
            });
      state.pagination = pagination;
    },

    [getClients.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const clientsSelector = (state) => state.clients;

export const { reducer, actions } = clientsSlice;
